import { useState } from "react";
import { toast } from "sonner";
import { FastForward, Loader2 } from "lucide-react";
import { http, errMsg } from "../../lib/api";

export const FinishNowButton = ({ kitId, reload }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (!window.confirm("Stop the current step and move this kit to Review as it is? Everything written so far is kept and no more AI credit is spent on this run.")) return;
    setBusy(true);
    try { await http.post(`/kits/${kitId}/finish-now`); toast.success("Finished as-is — the kit is in Review"); reload(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <button data-testid="finish-now-button" onClick={go} disabled={busy}
      className="inline-flex items-center gap-2 rounded-sm border border-amber-500/60 px-4 py-2 text-sm font-semibold text-amber-700 hover:bg-amber-50 transition-colors disabled:opacity-40">
      {busy ? <Loader2 size={15} className="animate-spin" /> : <FastForward size={15} />} Finish now
    </button>
  );
};
